import { useTranslation } from 'react-i18next';

import { PageSeo } from '../components/PageSeo';
import { SubpageLayout } from '../components/SubpageLayout';
import { DUAYEN_60_VIDEO_URL } from '../data/duayenUyeler60Content';

/**
 * 60. yıl duayen üyeler — URL: /60-year-honorary-members
 */
export function DuayenUyeler60Page() {
    const { t } = useTranslation();

    return (
        <>
            <PageSeo
                title={`${t('duayenUyeler60.title')} — ${t('header.rotaryAlt')}`}
                description={t('seo.duayen60')}
            />
            <SubpageLayout
                title={t('duayenUyeler60.title')}
                subtitle={t('duayenUyeler60.subtitle')}
                contentClassName="subpage-video-page"
            >
            <div className="subpage-video-wrap">
                <video
                    className="subpage-video"
                    controls
                    playsInline
                    preload="metadata"
                    aria-label={t('duayenUyeler60.videoAriaLabel')}
                >
                    <source src={DUAYEN_60_VIDEO_URL} type="video/mp4" />
                    {t('duayenUyeler60.videoNotSupported')}
                </video>
            </div>
        </SubpageLayout>
        </>
    );
}
